import { forwardRef } from 'react';

import { IconProps } from '@sternum/web/icons/icons.types';

export const SearchStatusIcon = forwardRef<SVGSVGElement, IconProps>(function SearchStatusIcon(
  { color = '', height = 12, width = 12, hasCursorPointer = false, ...props },
  ref,
) {
  return (
    <svg
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-has-cursor-pointer={hasCursorPointer}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.69767 2.09302C6.69767 1.86183 6.88509 1.67442 7.11628 1.67442H8.7907H10.4651C10.6963 1.67442 10.8837 1.86183 10.8837 2.09302C10.8837 2.32421 10.6963 2.51163 10.4651 2.51163H7.11628C6.88509 2.51163 6.69767 2.32421 6.69767 2.09302Z"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.69767 3.76744C6.69767 3.53625 6.88509 3.34884 7.11628 3.34884H8.7907C9.02189 3.34884 9.2093 3.53625 9.2093 3.76744C9.2093 3.99863 9.02189 4.18605 8.7907 4.18605H7.11628C6.88509 4.18605 6.69767 3.99863 6.69767 3.76744Z"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.72093 0.837209C3.02189 0.837209 0.837209 3.02189 0.837209 5.72093C0.837209 8.41997 3.02189 10.6047 5.72093 10.6047C8.41997 10.6047 10.6047 8.41997 10.6047 5.72093C10.6047 5.48974 10.7921 5.30233 11.0233 5.30233C11.2544 5.30233 11.4419 5.48974 11.4419 5.72093C11.4419 8.88235 8.88235 11.4419 5.72093 11.4419C2.55951 11.4419 0 8.88235 0 5.72093C0 2.55951 2.55951 0 5.72093 0C5.95212 0 6.13953 0.187416 6.13953 0.418605C6.13953 0.649794 5.95212 0.837209 5.72093 0.837209Z"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.1691 10.1691C10.3326 10.0056 10.5976 10.0056 10.7611 10.1691L11.8774 11.2854C12.0409 11.4489 12.0409 11.7139 11.8774 11.8774C11.7139 12.0409 11.4489 12.0409 11.2854 11.8774L10.1691 10.7611C10.0056 10.5976 10.0056 10.3326 10.1691 10.1691Z"
        fill={color || 'currentColor'}
      />
    </svg>
  );
});
